// Copyright (C) 2017-2023 Smart code 203358507

const { createContext } = require('react');

const TooltipContext = createContext(null);

module.exports = TooltipContext;

